module.exports = __webpack_public_path__ + "media/frontend/assets/icons/icon-more-f4dc37a113c32b4e0ec22c250e12ebc1.png";